var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBatchApplications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-289 381 32 32",
    style: {
      enableBackground: "new -289 381 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F8DDE6;}\n\t.st1{fill:#CF817E;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-283.6,386.5 -283.6,393.2 -283.6,411.5 -258.6,411.5 -258.6,393.2 -258.6,386.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8,412.2h-26.5v-26.4h26.5V412.2z M-282.8,410.7h23.5v-23.4h-23.5V410.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -287.4,
    y: 382.5,
    className: "st0",
    width: 25,
    height: 6.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-261.7,389.9h-26.5v-8.2h26.5V389.9z M-286.7,388.4h23.5v-5.2h-23.5V388.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -287.4,
    y: 389.1,
    className: "st2",
    width: 25,
    height: 18.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-261.7,408.2h-26.5v-19.8h26.5V408.2z M-286.7,406.7h23.5v-16.8h-23.5V406.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -269.9,
    y: 385.1,
    className: "st1",
    width: 1.5,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -266.5,
    y: 385.1,
    className: "st1",
    width: 1.5,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -284.5,
    y: 385.1,
    className: "st1",
    width: 3.8,
    height: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchApplications);
export default __webpack_public_path__ + "static/media/batch_applications.59d69922364a1ec19a136825eaf2a228.svg";
export { ForwardRef as ReactComponent };